import React from 'react';
import { Outlet } from 'react-router-dom';
import PatSidebar from '../../components/common/PatSidebar';

export default function PatLayout() {
  return (
    <div className="min-h-screen bg-gray-100">
      <PatSidebar />
      <div className="lg:ml-64">
        <Outlet />
      </div>
    </div>
  );
}